const PROXY_URL = 'https://pb.movemaestro.com/v3/mmapi/';
const TWS_LOGIN = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/twslogin';
const TWS_FORGOT_LOGIN = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/TWSForgotLogin';
const TWS_REGISTER = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/twsregister?client=uniform';
const TWS_CIVIL_REGISTER = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/twsregister?client=civilian';
const QAS = 'https://tolltwsfunctionsoutheast-prod.azurewebsites.net/api/QAS';
const AAD = 'movemaestro.com';
const USE_OLD_LOGIN = false;
const USE_REDIRECT = false;
const LOGIN_CLIENT_ID = 'dac7b3a2-9cab-4728-94c1-d78fd80e84b4';
const LOGIN_SCOPE = 'https://ab.movemaestro.com/.default';

module.exports = {
    PROXY_URL
    ,TWS_LOGIN
    ,TWS_FORGOT_LOGIN
    ,TWS_REGISTER
    ,QAS
    ,AAD
    ,TWS_CIVIL_REGISTER
    ,USE_OLD_LOGIN
    ,USE_REDIRECT
    ,LOGIN_CLIENT_ID
    ,LOGIN_SCOPE
}